import { GitMergeIcon, MarkGithubIcon } from '@primer/octicons-react'
import { match } from 'ts-pattern'
import AzureLightIcon from '../components/icons/azure-light.svg?react'
import BitbucketIcon from '../components/icons/bitbucket-icon.svg?react'
import GitlabIcon from '../components/icons/gitlab-icon.svg?react'
import { Repository } from './api-client/api-schemas'

interface GetRepositoryIconProps {
  type: Repository['type']
  className?: string
}

/**
 * Returns the appropriate SCM icon component based on the repository type
 * @param type - The type of repository (azure, github, gitlab, etc.)
 * @param className - Optional CSS class name to apply to the icon
 * @returns A React component representing the repository's SCM icon
 */
export const getRepositoryIcon = ({ type, className }: GetRepositoryIconProps) => {
  return match(type)
    .with('azure', () => <AzureLightIcon aria-label="Azure icon" className={className} />)
    .with('github', () => <MarkGithubIcon aria-label="GitHub icon" className={className} />)
    .with('gitlab', () => <GitlabIcon aria-label="GitLab icon" className={className} />)
    .with('bitbucket', () => <BitbucketIcon aria-label="Bitbucket icon" className={className} />)
    .with('git', () => <GitMergeIcon aria-label="Git icon" className={className} />)
    .otherwise(() => <GitMergeIcon aria-label="Git icon" className={className} />)
}
